import React from 'react';

import { range } from '@utils/array';

import DarkSkeleton from './DarkSkeleton';

import './SkeletonList.scss';

interface Props {
    count?: number;
    height?: number;
}

const SkeletonList = ({ count = 3, height = 15 }: Props) => (
    <div className="skeleton-list-wrapper">
        <ul>
            {range(count).map((i) => (
                <li key={`skeleton-${i}`}>
                    <div>
                        <DarkSkeleton height={height} />
                    </div>
                </li>
            ))}
        </ul>
    </div>
);

export default SkeletonList;
